module.exports = {
      id: "72c27189f374db36742297ea212f439egas-individual.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#72c27189f374db36742297ea212f439egas-individual.svg",
      toString: function () {
        return this.url;
      }
    }